import type { CSSProperties } from 'react';
import type { IProgressBarProps } from './ProgressBar.interface';
import {
    classNameForElement,
    progressToText,
    StyleElem,
    styleForElement,
} from './ProgressBar.style';

function ProgressBar(props: IProgressBarProps): JSX.Element {
    const style = (element: StyleElem, overrides?: CSSProperties) =>
        styleForElement(element, props, overrides);
    const className = (element: StyleElem) => classNameForElement(element, props);

    const progressDescription = progressToText(props.progress);

    return (
        <div
            aria-hidden
            className={`${className(StyleElem.Container)} ${props.className ?? ''}`}
            style={style(StyleElem.Container, props.style)}
            role="progressbar"
            aria-label={props.description ?? 'Progress bar'}
            aria-valuemin={0}
            aria-valuemax={1}
            aria-valuenow={Math.max(Math.min(props.progress, 1), 0)}
            aria-valuetext={progressDescription}
        >
            <div
                className={className(StyleElem.Bar)}
                style={style(StyleElem.Bar)}
                aria-hidden={true}
            />
            <div
                className={className(StyleElem.Text)}
                style={style(StyleElem.Text)}
                aria-hidden={true}
            >
                <span style={{ zIndex: 1 }}>{progressDescription}</span>
            </div>
        </div>
    );
}

export default ProgressBar;
